import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { LayerPermissionsService } from '../service/Admin.layerPermissionsService'
import { toast } from '@app/components/ui/Toast/toast'
import type { UserRole, LayerPermissionsResponse } from '@app/types'
import { LAYER_PERMISSIONS_QUERY_KEY } from '../utils/Admin.constants'

export const useFetchLayerPermissions = (page: number, pageSize: number, layerType: string) => {
  return useQuery<LayerPermissionsResponse[]>({
    queryKey: [LAYER_PERMISSIONS_QUERY_KEY, page, pageSize, layerType],
    queryFn: async () => {
      try {
        return await LayerPermissionsService.getLayerPermissions(page, pageSize, layerType)
      } catch (error: unknown) {
        throw error
      }
    },
  })
}

export const useUpdateLayerPermissions = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ layerId, user_roles }: { layerId: number; user_roles: UserRole[] }) =>
      LayerPermissionsService.updateLayerPermissions(layerId, user_roles),
    onSuccess: () => {
      toast({
        description: `Layer permissions updated successfully.`,
        position: 'top-right',
        type: 'success',
      })
      queryClient.invalidateQueries({ queryKey: [LAYER_PERMISSIONS_QUERY_KEY] })
    },
    onError: () =>
      toast({
        description: `Failed to update layer permissions.`,
        position: 'top-right',
        type: 'error',
      }),
  })
}
